(function(angular){
    'use strict';

    angular.module('mychart').component('apPrintablePatientInfo', {
        templateUrl: '/mychart/views/components/apPrintablePatientInfo.html',
        controllerAs: 'vm',
        controller: [
            'MyChartService',
            'PatientPortalStorageRepository',
            ApPrintablePatientInfo,
        ],
    });

    function ApPrintablePatientInfo(
        MyChartService,
        PatientPortalStorageRepository
    ) {
        var vm = this;
        vm.fullName = null;
        vm.age = null;
        vm.birthDate = null;

        activate();

        function activate() {
            var patient = PatientPortalStorageRepository.getActivePatient();
            MyChartService.getDetails(patient.id).then(function(details) {
                if(details) {
                    vm.fullName = details.FirstName + ' ' + details.LastName;
                    vm.age = details.Age;
                    vm.birthDate = details.DateOfBirth;
                }
            });
        }
    }

})(window.angular);